<template>
  <div class="coupling-popup" :class="device">
    <div class="popup-header">
      <div class="heading">
        <span class="title">
          <span v-text="$t('hose.coupling') + ' ' + (popup === 'couplingA' ? 'A' : 'B')"></span>
        </span>

        <div class="material">
          <span class="text">{{ $t('hose.couplingPopup.show') }}</span>
          <tabs
              v-if="popup === 'couplingA'"
              :info="false"
              :options="{
               'steel': $t('hose.couplingPopup.steel'),
               'rvs': $t('hose.couplingPopup.stainlessSteel'),
              }"
              v-model="materialA"
          ></tabs>
          <tabs
              v-else
              :info="false"
              :options="{
               'steel': $t('hose.couplingPopup.steel'),
               'rvs': $t('hose.couplingPopup.stainlessSteel'),
              }"
              v-model="materialB"
          ></tabs>
        </div>
        <span class="close-btn" @click="$emit('close')">&times;</span>
      </div>
    </div>

    <div class="coupling-categories" v-if="popup === 'couplingA'">
      <category-card
          v-for="category in filteredCouplingCategories"
          :key="category.name"
          :category="category"
          v-model="selectedCategoryA"
      ></category-card>
    </div>

    <div class="coupling-categories" v-else>
      <category-card
          v-for="category in filteredCouplingCategories"
          :key="category.name"
          :category="category"
          v-model="selectedCategoryB"
      ></category-card>
    </div>


    <span class="results">{{ $t('hose.couplingPopup.results') }}
      {{
        popup === 'couplingA' ? selectedCategoryA ? translate(selectedCategoryA) : $t('hose.couplingPopup.allCouplings') : selectedCategoryB ? translate(selectedCategoryB) : $t('hose.couplingPopup.allCouplings')
      }}
    </span>

    <div class="grid-table couplings" :class="device">
      <div class="grid-row header">
        <div class="grid-col-1 grid-col">
          <span class="text">{{ $t('hose.couplingPopup.name') }}</span>
        </div>
        <div class="grid-col-3 grid-col">
          <span class="text">{{ $t('hose.couplingPopup.measurement') }}</span>
        </div>
        <div class="grid-col-4 grid-col">
          <span class="text">{{ $t('hose.couplingPopup.r1') }}</span>
        </div>
        <div class="grid-col-5 grid-col">
          <span class="text">{{ $t('hose.couplingPopup.innerRod') }}</span>
        </div>
        <div class="grid-col-6 grid-col">
          <span class="text">{{ $t('hose.couplingPopup.outerRod') }}</span>
        </div>
        <div class="grid-col-7 grid-col">
          <span class="text">{{ $t('hose.couplingPopup.keyMeasurement') }}</span>
        </div>
        <div class="grid-col-8 grid-col">
          <span class="text">{{ $t('hose.couplingPopup.maxPressure') }}</span>
        </div>
        <div class="grid-col-9 grid-col">
          <span class="text"></span>
        </div>
      </div>

      <template v-if="popup === 'couplingA'">
        <grid-row-couplings
            v-for="coupling in sortedCouplings"
            :key="coupling.id"
            :coupling="coupling"
            v-model="selectedCouplingA"
        >
        </grid-row-couplings>
      </template>
      <template v-if="popup === 'couplingB'">
        <grid-row-couplings
            v-for="coupling in sortedCouplings"
            :key="coupling.id"
            :coupling="coupling"
            v-model="selectedCouplingB"
        >
        </grid-row-couplings>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CategoryCard from "@/components/hose/components/CategoryCard";
import GridRowCouplings from "@/components/hose/components/GridRowCouplings";
import Popup from "@/components/popup/Popup";
import Tabs from "@/components/hose/components/Tabs";

export default {
  name: "PopupCouplings",

  props: {
    popup: {
      type: String,
      required: true,
    },
  },

  components: {Tabs, Popup, GridRowCouplings, CategoryCard},

  computed: {
    ...mapGetters({
      preferences: 'build/hoses/getHosePreferences',
      couplingCategories: "build/hoses/couplings/getAllCategories",
      build: "build/hoses/getHoseBuild",
      couplings: "build/hoses/couplings/getAllCouplings",
      device: 'getDevice',
    }),
    filteredCouplingCategories() {
      return this.couplingCategories.filter((category) => {
        return this.couplings.find((coupling) => {
          const inCategory = coupling.category_id === category.id;
          const popupMaterial = this.popup === 'couplingA' ? this.materialA : this.materialB;
          const materialMatches = coupling.material === popupMaterial;
          const fitsOnHose =  coupling.measurement_dn === this.build.selectedHose.measurement_dn

          return inCategory && materialMatches && fitsOnHose;
        }) !== undefined
      });
    },
    materialA: {
      get() {
        return this.preferences.materialA;
      },
      set(val) {
        this.$store.commit('build/hoses/setMaterialA', val);
      },
    },
    materialB: {
      get() {
        return this.preferences.materialB;
      },
      set(val) {
        this.$store.commit('build/hoses/setMaterialB', val);
      },
    },
    selectedCategoryA: {
      get() {
        return this.build.selectedCategoryA;
      },
      set(val) {
        this.$store.commit('build/hoses/setSelectedCategoryA', val);
      },
    },
    selectedCategoryB: {
      get() {
        return this.build.selectedCategoryB;
      },
      set(val) {
        this.$store.commit('build/hoses/setSelectedCategoryB', val);
      },
    },
    selectedCouplingA: {
      get() {
        return this.build.couplingA;
      },
      set(val) {
        this.$store.dispatch('build/hoses/setCouplingA', val);
        this.$emit('close');
      },
    },
    selectedCouplingB: {
      get() {
        return this.build.couplingB;
      },
      set(val) {
        this.$store.dispatch('build/hoses/setCouplingB', val);
        this.$emit('close');
      },
    },
    sortedCouplings() {
      let couplings = this.couplings;
      let build = this.build;
      let material = (this.popup === 'couplingA' ? this.materialA : this.materialB);
      let category = (this.popup === 'couplingA' ? this.selectedCategoryA : this.selectedCategoryB);

      if (category !== null) {
        return couplings.filter(function (coupling) {
          return coupling.material === material &&
              coupling.measurement_dn === build.selectedHose.measurement_dn &&
              _.isEqual(coupling.coupling_category.category_name, category);
        });
      } else {
        return couplings.filter(function (coupling) {
          return coupling.material === material &&
              coupling.measurement_dn === build.selectedHose.measurement_dn;
        });
      }
    },
  },
}
</script>

<style scoped lang="scss">
.coupling-popup {
  display: flex;
  padding: 13px 25px;
  flex-direction: column;

  &.mobile {
    overflow-y: scroll;
  }

  .heading {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;

    @media only screen and (max-width: 398px) {
      flex-wrap: wrap;
    }

    .title {
      font-size: 20px;
      font-family: neue-haas-grotesk-display, sans-serif;
    }

    .material {
      display: flex;
      margin-left: 70px;
      align-items: center;

      .tabs {
        width: 150px;
      }

      .text {
        margin-right: 9px;
        font-size: 14px;
        font-family: neue-haas-grotesk-display, sans-serif;
      }
    }

    .close-btn {
      color: #A4AFB7;
      font-size: 30px;
      cursor: pointer;
      margin-left: auto;
      display: block;
      transition: all ease 0.3s;

      @media only screen and (max-width: 398px) {
        position: relative;
        top: -35px;
        right: 0;
      }

      &:hover {
        color: darken(#A4AFB7, 40%);
      }
    }
  }
}

.coupling-categories {
  padding: 13px 0 22px;
  display: flex;
  justify-content: left;
}

.results {
  font-size: 14px;
  font-family: neue-haas-grotesk-display, sans-serif;
}

.grid-table {
  margin-top: 10px;
  padding-bottom: 30px;
  max-height: 400px;
  overflow: scroll;

  &.mobile {
    min-width: 100%;

    .grid-row {
      min-width: 1100px;
      min-height: 35px;
    }

    .header {
      min-width: 1100px;
      overflow: scroll;
      min-height: 50px;
    }
  }

  .grid-row {
    background-color: white;
    grid-template-columns: 4fr repeat(7, 2fr) 3fr;

    .grid-col-9 {
      grid-row: 1 / 2;
      grid-column: 9/10;
    }

    &:nth-child(even) {
      background-color: #EBEBEB;

      &.active {
        background-color: rgba(61, 176, 199, 0.25);
      }
    }

    &.mobile {
      grid-template-columns: 4fr repeat(7, 2fr) 3fr;
    }
  }
}
</style>
